import axios from 'axios'

import appConfig from '@/config/app'

const httpClient = axios.create({
  baseURL: `${appConfig.apiBaseUrl  }/api/${  appConfig.apiVersion}`
})

export default httpClient
